import { ApolloProvider } from '@apollo/client/react'
import React, { useEffect } from 'react'
import { useClearCache } from 'react-clear-cache'
import { BrowserRouter } from 'react-router-dom'
import MainWrapper from './containers/MainWrapper'
import { CombinedProviders } from './context/CombinedProviders'
import './shared/i18n/i18n'
import client from './shared/store/client'
import ReactGA from 'react-ga4'
import { GA_MEASUREMENT_ID } from './variables'
import { analyticsPageFields } from './utils/analyticsPage'

ReactGA.initialize(GA_MEASUREMENT_ID)
// a tab's title can name a patient or a user: Google Analytics is given the page's path instead, from the start
ReactGA.set(analyticsPageFields(window.location.pathname))

const App = () => {
  const { isLatestVersion, emptyCacheStorage } = useClearCache()

  useEffect(() => {
    !isLatestVersion && emptyCacheStorage()
  }, [isLatestVersion, emptyCacheStorage])

  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <CombinedProviders>
          <MainWrapper />
        </CombinedProviders>
      </BrowserRouter>
    </ApolloProvider>
  )
}

export default App
